import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { DxDiagnosisQuestion } from '@src/api/types/dxDiagnosisQuestion';
import { DxDiagnosisStep } from '@src/api/types/dxDiagnosisStep';

type CompanyDxDiagnosisStepIndexResponse = DxDiagnosisStep[];

type CompanyDxDiagnosisStepShowResponse = DxDiagnosisQuestion[];

export const companyDxDiagnosisStepApiClient = {
  index: async (): Promise<ApiResult<CompanyDxDiagnosisStepIndexResponse>> => {
    return await axiosClient.get('/company/dx-diagnosis-steps');
  },
  show: async (id: number): Promise<ApiResult<CompanyDxDiagnosisStepShowResponse>> => {
    return await axiosClient.get(`/company/dx-diagnosis-steps/${id}`);
  },
};
